import { render, staticRenderFns } from "./UtilsView.vue?vue&type=template&id=98f5ece0&scoped=true&"
import script from "./UtilsView.vue?vue&type=script&lang=js&"
export * from "./UtilsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f5ece0",
  null
  
)

export default component.exports